export enum contactPreferenceEnum {
  noContactInfo = 'NO_CONTACT_INFO',
  updateContactInfo = 'UPDATE_CONTACT_INFO',
  retainContactInfo = 'RETAIN_CONTACT_INFO'
}

export const hardcodedContactData = {
  phone_number: {
    country_code: '1',
    national_number: '4081111111'
  },
  email_address: 'buyer_shipping_email@example.com'
};
